<template>
  <div class="page">
    <h1>Conversations</h1>
    <SubPageNav
      :links="[
    {name:'myConversations', text:'Mes Conversations'}
    ]"
      :add="{name:'addConversation'}"
    ></SubPageNav>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <InPageNav></InPageNav>
  </div>
</template>

<script>
import SubPageNav from "@/components/SubPageNav.vue";
import InPageNav from "@/components/InPageNav.vue";

export default {
  name: "Conversations",
  components: {
    SubPageNav,
    InPageNav
  }
};
</script>
<style>
</style>